export const Archivistico_item = [
  {
    archivistico_item_nombre: " 2026",
    archivistico_item_url: "../../../contenido/informacion/publicaciones/PADA-SESA-2026.pdf",
    archivistico_item_titulo: "Año 2026"
  },
  {
    archivistico_item_nombre: " 2025",
    archivistico_item_url: "../../../contenido/informacion/publicaciones/PADA-SESA-2025.pdf",
    archivistico_item_titulo: "Año 2025"
  },
  {
    archivistico_item_nombre: " 2024",
    archivistico_item_url: "../../../contenido/informacion/PROGRAMA ANUAL (PADA) 2024.pdf",
    archivistico_item_titulo: "Año 2024"
  },
  {
    archivistico_item_nombre: " 2023",
    archivistico_item_url: "../../../contenido/informacion/PROGRAMA-ANUAL-DESARROLLO-ARCHIVISTICO(PADA)-2023.pdf",
    archivistico_item_titulo: "Año 2023"
  },
  {
    archivistico_item_nombre: " 2022",
    archivistico_item_url: "../../../contenido/informacion/publicaciones/PADA-SESA-2022.pdf",
    archivistico_item_titulo: "Año 2022"
  },
];
